<template>
  <div class="search fixed-nav">
    <MainHeader
      :dark="false"
      :fixedMenu="true"
      :loginButton="false"
      :tiles="false"
      @logoClick="logoClick"
    >
      <svg>
        <use v-if="selectedTranslation === 'en'" xlink:href="#logoMkSvgEng"></use>
        <use v-else xlink:href="#logoMkSvg"></use>
      </svg>
    </MainHeader>
    <div class="sections">
      <section class="section-main container-expand container-expand-404 bg-light2">
        <div class="container container-small">
          <AccentHeader
            :header="errorData.pageNotFound.header + '<br/>' + errorData.pageNotFound.code"
            :underline="true"
            :uppercase="false"
          />
          <div class="error-404">
            {{ errorData.pageNotFound.description }}
          </div>
        </div>
      </section>
      <MainFooter
        key="footer"
        :content="footerData"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AccentHeader from '@/components/AccentHeader.vue'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'

export default {
  name: 'notfound',
  components: {
    AccentHeader,
    MainHeader,
    MainFooter
  },
  data: function () {
    return {
    }
  },
  methods: {
    ...mapActions([
      'resetActiveFilters'
    ]),
    logoClick () {
      this.$router.push({ 'path': '/' })
    }
  },
  computed: {
    ...mapGetters([
      'errorData',
      'footerData',
      'selectedTranslation'
    ])
  },
  mounted () {
    this.resetActiveFilters()
  }
}
</script>

<style scoped lang="scss">
</style>
